import http from '@/http'
import Role from '@/store/models/Role'

const API_PATH = 'organizations/:organizationId/roles/'

const configureApiPath = ({ organizationId }) => {
  return API_PATH.replace(':organizationId', organizationId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async index({ commit, rootGetters }) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    await http.get(apiPath).then(response => {
      Role.deleteAll()
      Role.insert({
        data: response.data.data.map(role => role.attributes)
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
